import styled from "@emotion/styled";

export const Wrapper = styled.div`
  display: grid;
  gap: 6px;

  :not(:last-child) {
    margin-bottom: ${p => p.theme.space[5]}px;
  }

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    grid-template-columns: repeat(2, 1fr);
    margin-bottom: ${p => p.theme.space[0]} !important;
    gap: 0;

    border-bottom: 1px solid ${p => p.theme.colors.secondary.stroke};
  }
`;

export const LabelWrapper = styled.div`
  padding: 0;
  font-size: ${p => p.theme.fontSizes.m};
  font-weight: ${p => p.theme.fontWeight.medium};
  color: ${p => p.theme.colors.secondary.gray};

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    padding: 12px 4px;
  }
`;

export const List = styled.ul`
  padding-left: ${p => p.theme.space[6]}px;

  li {
    list-style: disc;
    font-size: ${p => p.theme.fontSizes.m};
    font-weight: ${p => p.theme.fontWeight.medium};
    color: ${p => p.theme.colors.secondary.gray};
  }

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    padding-top: 14px;
    padding-bottom: 14px;
    margin-bottom: 0;
  }
`;
